<template>
  <ul class="navbar-nav" :class="{'ml-nav-mobile': $store.getters.instanceLoaded}">
    <!-- ///////////// LIVE MODE Start ///////////// -->
    <li class="nav-item" v-if="$route.name !== 'InstanceManagement' && $route.name !== 'home'">
      <router-link tag="a" class="nav-link active" :to="{name: 'home'}">
        <i class="fa fa-home"></i> Dashboard
      </router-link>
    </li>

    <li class="nav-item dropdown" v-if="$store.getters.instanceLoaded" style="z-index: 100;">
      <!-- Shown on [SM - MD] -->
      <a class="nav-link dropdown-toggle active pointer d-none d-lg-block d-xl-none" @click="openDropDownMenu('controls')">
        <i class="fas fa-desktop"></i>
      </a>
      <!-- Shown on [SM, XL] -->
      <a class="nav-link dropdown-toggle active pointer d-block d-lg-none d-xl-block" @click="openDropDownMenu('controls')">
        <i class="fas fa-desktop"></i> &nbsp;{{ $t('UI_NAV_CONTROL') }}
      </a>

      <!-- Live Mode Controls -->
      <LiveModeControls/>
    </li>
    <!-- ///////////// LIVE MODE END ///////////// -->

    <!-- ///////////// SETTINGS START ///////////// -->
    <li class="nav-item dropdown" style="z-index: 100;">
      <!-- Shown on [SM - MD] -->
      <a class="nav-link dropdown-toggle active pointer d-none d-lg-block d-xl-none" @click="openDropDownMenu('settings')">
        <i class="fas fa-cogs"></i>
      </a>
      <!-- Shown on [SM, XL] -->
      <a class="nav-link dropdown-toggle active pointer d-block d-lg-none d-xl-block" @click="openDropDownMenu('settings')">
        <i class="fas fa-cogs"></i> {{ $t('UI_NAV_SETTINGS') }}
      </a>

      <div class="dropdown-menu" :class="{show: openedDropdownMenu === 'settings'}" v-if="$store.state.user !== null">
        <div v-if="$store.state.user.hasMultipleChannels">
          <!-- Channel Select -->
          <h6 class="dropdown-header">{{ $t('UI_NAV_ADMIN_CHANNEL') }}</h6>
          <button class="dropdown-item" v-if="$store.getters.instanceLoaded"
                  @click="$snotify.error($t('UI_START_CHANNEL_SELECTION_DISABLED'))">
            {{ $t('UI_NAV_ADMIN_SELECT_CHANNEL') }}
          </button>
          <button class="dropdown-item" @click="$refs.channelListModal.open()" v-else>
            {{ $t('UI_NAV_ADMIN_SELECT_CHANNEL') }}
          </button>
          <button class="dropdown-item" @click="$snotify.error($t('UI_START_CHANNEL_SETTINGS_DISABLED'))"
                  v-if="$store.getters.instanceLoaded">
            {{ $t('UI_NAV_SETTINGS_CHANNEL_SETTINGS') }}
          </button>
          <router-link tag="a" class="dropdown-item" :to="{name: 'channel-settings'}" v-else>
            {{ $t('UI_NAV_SETTINGS_CHANNEL_SETTINGS') }}
          </router-link>
        </div>


        <!-- Instance Specific -->
        <div v-if="$store.getters.instanceLoaded">
          <div class="dropdown-divider"></div>
          <h6 class="dropdown-header">{{ $t('UI_NAV_SETTINGS_INSTANCE') }}</h6>
          <button class="dropdown-item" @click="$refs.instanceSettings.$refs.instanceSettingsModal.open()">
            {{ $t('UI_NAV_SETTINGS_INSTANCE_SETTINGS') }}
          </button>
        </div>

        <DataImporterRunScript/>

        <div class="dropdown-divider"></div>
        <h6 class="dropdown-header">
          {{ $t('UI_NAV_SETTINGS_LANGUAGE') }}
        </h6>
        <button class="dropdown-item language-setter" :class="{active: $i18n.locale === 'en'}"
               @click="setLocale('en')">English
        </button>
        <button class="dropdown-item language-setter" :class="{active: $i18n.locale === 'fr'}"
                @click="setLocale('fr')">Français
        </button>
        <button class="dropdown-item language-setter" :class="{active: $i18n.locale === 'de'}"
                @click="setLocale('de')">Deutsch
        </button>

      </div>
    </li>
    <!-- ///////////// SETTINGS END ///////////// -->


    <!-- ///////////// ADMIN START ///////////// -->
    <li class="nav-item dropdown" v-if="$store.getters.isLoggedIn && $store.state.user.isAdmin" style="z-index: 100;">
      <!-- Shown on [SM - MD] -->
      <a class="nav-link dropdown-toggle active pointer d-none d-lg-block d-xl-none" @click="openDropDownMenu('admin')">
        <i class="fas fa-wrench"></i>
      </a>
      <!-- Shown on [SM, XL] -->
      <a class="nav-link dropdown-toggle active pointer d-block d-lg-none d-xl-block" @click="openDropDownMenu('admin')">
        <i class="fas fa-wrench"></i> &nbsp;{{ $t('UI_NAV_ADMIN') }}
      </a>

      <AdminMenuNavbarAction/>
    </li>
    <!-- ///////////// ADMIN END ///////////// -->


    <!-- ///////////// USER MENU START ///////////// -->
    <li class="nav-item dropdown" v-if="$store.getters.isLoggedIn && !$store.getters.instanceLoaded" style="z-index: 100;">
      <!-- Shown on [SM - MD] -->
      <a class="nav-link dropdown-toggle active pointer d-none d-lg-block d-xl-none" @click="openDropDownMenu('user')">
        <i class="fas fa-user"></i>
      </a>
      <!-- Shown on [SM, XL] -->
      <a class="nav-link dropdown-toggle active pointer d-block d-lg-none d-xl-block" @click="openDropDownMenu('user')">
        <i class="fas fa-user"></i> &nbsp;{{ $store.state.user.username }}
      </a>

      <div class="dropdown-menu dropdown-menu-right bg-danger" :class="{show: openedDropdownMenu === 'user'}">
        <!--  <h6 class="dropdown-header">{{ $t("UI_NAV_LOGOUT") }}</h6> -->

        <button class="dropdown-item bg-danger" @click="logout">
          <i class="fas fa-sign-out-alt text-white"></i>
          <span class="text-white">
            {{ $t("UI_NAV_LOGOUT") }}
          </span>
        </button>

      </div>
    </li>
    <!-- ///////////// USER MENU END ///////////// -->

    <!-- Buttons -->
    <div class="nav-item" v-if="$store.getters.instanceLoaded">
      <button class="btn btn-success" @click="saveInstance">
        <i class="fas fa-save"></i>
        <span class="d-none d-xl-inline">&nbsp;Save</span>
      </button>
      <button class="btn btn-danger ml-1" @click="$refs.releaseInstanceDialog.open()">
        <i class="fas fa-times-circle"></i>
        <span class="d-none d-xl-inline">&nbsp;Close</span>
      </button>
    </div>

    <!-- Channel Selection Modal -->
    <SweetModal ref="channelListModal" v-on:open="getChannels" :title="$t('UI_START_CHANNEL_SELECT_TITLE')"
                style="min-height: 500px" :blocking="true" :pulse-on-block="false">
      {{ $t('UI_START_CHANNEL_SELECT_TEXT') }}
.
      <v-select label="title"
                :options="channels.list"
                v-model="selectedChannel"
                v-on:search:focus="expanded = true"
                v-on:search:blur="expanded = false">
        <template v-slot:option="channel">
          <template v-if="channel.isLive">
            <span style="float:left">{{ channel.title }}</span>
            <span style="float:right; font-size: 14px" class="badge badge-danger">LIVE</span>
            <div style="clear:both"></div>
          </template>
          <template v-else>
            {{ channel.title }}
          </template>
        </template>
      </v-select>

      <div style="height: 330px;" v-if="expanded"></div>

      <div slot="button">
        <button class="btn btn-primary" v-if="selectedChannel" @click="selectChannel">{{ $t('UI_MODEL_BUTTON_SELECT')
          }}
        </button>
        <button class="btn btn-secondary ml-1" @click="$refs.channelListModal.close()">{{ $t('UI_MODAL_BUTTON_CLOSE')
          }}
        </button>
      </div>
    </SweetModal>

    <!-- Close Instance dialog -->
    <SweetModal ref="releaseInstanceDialog" :title="$t('UI_CLOSE_INSTANCE_DIALOG_TITLE')" icon="warning"
                :blocking="true" :pulse-on-block="false">
      {{ $t('UI_CLOSE_INSTANCE_DIALOG_WARNING') }}

      <div slot="button">
        <button class="btn btn-success" @click="saveAndRelease">
          {{ $t('UI_CLOSE_INSTANCE_DIALOG_SAVE_AND_CLOSE') }}
        </button>
        <button class="btn btn-danger ml-1" @click="releaseInstance">{{
          $t('UI_CLOSE_INSTANCE_DIALOG_CLOSE_WITHOUT_SAVING') }}
        </button>
        <button class="btn btn-secondary ml-1" @click="$refs.releaseInstanceDialog.close()">{{
          $t('UI_CLOSE_INSTANCE_DIALOG_ABORT') }}
        </button>
      </div>
    </SweetModal>

    <!--Instance Setting Modal-->
    <InstanceSettings ref="instanceSettings" v-if="$store.getters.instanceLoaded"></InstanceSettings>

  </ul>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../repositories/RepositoryFactory';
import InstanceSettings from './instance/InstanceSettings';
import LiveModeControls from './instance/LiveModeControls';
import AdminMenuNavbarAction from './NavbarActions/AdminMenuNavbarAction';
import DataImporterRunScript from './NavbarActions/DataImportRunScript';

const ChannelRepository = RepositoryFactory.get('adminChannels');
const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'NavBarControls',
  components: {
	  DataImporterRunScript,
    AdminMenuNavbarAction,
    LiveModeControls,
    InstanceSettings,
    SweetModal,
  },
  created() {

  },
  data() {
    return {
      openedDropdownMenu: '',
      channels: {
        list: [],
      },
      selectedChannel: null,
      newInstanceName: '',
      expanded: false,
    };
  },
  mounted() {
    const self = this;
    window.addEventListener('click', (e) => {
      const { classList } = e.target.parentNode;
      if (!classList.contains('nav-item') && !classList.contains('dropdown')) {
        self.openedDropdownMenu = '';
      }
    }, false);

    this.newInstanceName = this.activeInstanceName;
    InstanceRepository.refetchActive();
  },
  computed: {
    activeChannelName() {
      if (this.$store.state.channel !== null) {
        if (this.$store.state.channel.title !== null) {
          return this.$store.state.channel.title;
        }
      }
    },
    activeInstanceName() {
      if (this.$store.state.instance !== null) {
        return this.$store.state.instance.title !== null ? this.$store.state.instance.title : '';
      }
      return '';
    },
  },
  methods: {
	  setLocale(lang) {
	  	if (lang !== 'de' && lang !== 'fr' && lang !== 'en') return false;
	  	this.$i18n.locale = lang;
	  	this.$store.commit('setLocale', lang);
    },

    openDropDownMenu(menu) {
      if (this.openedDropdownMenu === menu) this.openedDropdownMenu = '';
      else this.openedDropdownMenu = menu;
    },

    async releaseInstance() {
      await InstanceRepository.release()
        .then((response) => {
          this.$snotify.info(this.$t('UI_INSTANCE_RELEASED'));
          this.$store.dispatch('setInstanceData', null);
          this.$store.dispatch('setVideoPlayerUrl', null);
          this.$store.dispatch('setShouldLoadVideoPlayer', false);
          this.$router.push({ name: 'home' });
        })
        .catch((error) => {
        });
      this.$refs.releaseInstanceDialog.close();
    },
    async saveInstance() {
      await InstanceRepository.save()
        .then((response) => {
          this.$snotify.info(this.$t('UI_INSTANCE_SAVED'));
        })
        .catch((error) => {
        });
      this.$refs.releaseInstanceDialog.close();
    },

    async saveAndRelease() {
      await this.saveInstance()
        .then(() => {
          this.releaseInstance();
        });
    },

    /**
       * Logs the User out.
       */
    async logout() {
      await this.$store.dispatch('logout')
        .then(() => {
          this.$snotify.info(this.$t('UI_LOGOUT_SUCCESS'));
          this.$nextTick(this.$router.push({ name: 'login' }));
        });
    },
    /**
       * Fetches a list of all channels
       *
       * @returns {Promise<void>}
       */
    async getChannels() {
      await ChannelRepository.getAll()
        .then((response) => {
          this.channels = response.data;
        })
        .catch((error) => {
        });
    },
    /**
       * Selects the Channel
       *
       * @returns {Promise<boolean>}
       */
    async selectChannel() {
      if (!this.selectedChannel) {
        return false;
      }

      await ChannelRepository.select(this.selectedChannel.chid)
        .then((response) => {
          this.$snotify.info(this.$t('UI_START_CHANNEL_CHANGED', { channel: response.data.title }));

          this.$store.dispatch('setSelectedChannel', {
            title: response.data.title,
            id: this.selectedChannel.chid,
          });
          this.selectedChannel = null;
        })
        .catch((error) => {
        });
      this.$refs.channelListModal.close();
    },
  },
};
</script>
